import { Skeleton } from "@/shadcnComponents/ui/skeleton";

export const TopLinksCardSkeleton = () => (
  <SectionCardSkeleton>
    <div className="flex items-start flex-wrap gap-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={`topLinkSkeleton_${i}`}
          className="bg-[#1B1F23] md:w-fit w-full rounded-[8px] border-[1px] border-solid border-[#262626] p-[1rem] md:py-[0.75rem] md:px-[1rem] flex justify-between gap-5 items-center"
        >
          <div className="flex gap-2 items-center">
            <div className="rounded-full shrink-0">
              <Skeleton className="size-[26px] rounded-full" />
            </div>
            <Skeleton className="h-[20px] w-[120px]" />
          </div>
          <Skeleton className="size-[16px]" />
        </div>
      ))}
    </div>
  </SectionCardSkeleton>
);

export const HighlightMetricsCardSkeleton = () => (
  <SectionCardSkeleton>
    <div className="w-full overflow-x-auto">
      <ul className="w-full grid grid-cols-2 md:flex items-start gap-[15px]">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={`HighLightSkeleton_${i}`}
            className="w-full flex p-[22px] rounded-[10px] bg-[#1B1F23] h-full"
          >
            <div className="flex items-center gap-[12px]">
              <div className="flex items-center justify-center">
                <Skeleton className="size-[25px] rounded-full" />
              </div>
              <div className="flex flex-col gap-[4px]">
                <Skeleton className="h-[24px] w-[60px]" />
                <Skeleton className="h-[16px] w-[80px]" />
              </div>
            </div>
          </div>
        ))}
      </ul>
    </div>
  </SectionCardSkeleton>
);

export const CollaborationPortfolioCardSkeleton = () => (
  <div className="animate-pulse p-4 bg-gray-800 rounded-lg min-w-[280px]">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 bg-gray-700 rounded-full"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-700 rounded w-24"></div>
        <div className="h-3 bg-gray-600 rounded w-32"></div>
      </div>
    </div>
    <div className="space-y-2">
      <div className="flex gap-2">
        <div className="h-6 bg-gray-700 rounded w-16"></div>
        <div className="h-6 bg-gray-700 rounded w-20"></div>
      </div>
      <div className="h-8 bg-gray-700 rounded w-full"></div>
    </div>
  </div>
);

export const MonetizationAvenueCardSkeleton = () => (
  <div className="animate-pulse p-4 bg-gray-800 rounded-lg min-w-[260px]">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-8 h-8 bg-gray-700 rounded"></div>
      <div className="h-4 bg-gray-700 rounded w-24"></div>
    </div>
    <div className="space-y-2">
      <div className="h-3 bg-gray-600 rounded w-32"></div>
      <div className="flex gap-2">
        <div className="h-5 bg-gray-700 rounded w-16"></div>
        <div className="h-5 bg-gray-700 rounded w-20"></div>
      </div>
    </div>
  </div>
);

export const TagChipSkeleton = () => (
  <div className="animate-pulse h-7 bg-gray-700 rounded-full w-20"></div>
);

export const AudienceAvenuesCardSkeleton = () => (
  <div className="animate-pulse p-4 bg-gray-800 rounded-lg min-w-[200px]">
    <div className="flex items-center gap-3 mb-2">
      <div className="w-6 h-6 bg-gray-700 rounded"></div>
      <div className="h-4 bg-gray-700 rounded w-20"></div>
    </div>
    <div className="h-6 bg-gray-600 rounded w-16"></div>
  </div>
);

export const ChartSkeleton = () => (
  <SectionCardSkeleton>
    <div className="w-full items-center justify-center flex flex-col gap-2">
      {/* Chart area skeleton */}
      <div className="m-auto w-full md:w-3/4">
        <Skeleton className="w-full h-[300px] rounded-[8px]" />
      </div>

      {/* Separator skeleton */}
      <Skeleton className="w-full md:w-3/4 h-[1px]" />

      {/* Latest/Oldest labels skeleton */}
      <div className="w-full md:w-3/4 flex items-center justify-between">
        <Skeleton className="h-[15px] w-[40px]" />
        <Skeleton className="h-[15px] w-[40px]" />
      </div>
    </div>
  </SectionCardSkeleton>
);

// export const TopPostsSkeleton = () => (
//   <div className="animate-pulse">
//     <SectionCardSkeleton />
//     <div className="mt-4 space-y-4">
//       {[1, 2, 3].map((i) => (
//         <div key={i} className="p-4 bg-gray-800 rounded-lg">
//           <div className="flex items-center gap-3 mb-3">
//             <div className="w-10 h-10 bg-gray-700 rounded-full"></div>
//             <div className="space-y-2">
//               <div className="h-4 bg-gray-700 rounded w-32"></div>
//               <div className="h-3 bg-gray-600 rounded w-24"></div>
//             </div>
//           </div>
//           <div className="space-y-2">
//             <div className="h-4 bg-gray-700 rounded w-full"></div>
//             <div className="h-4 bg-gray-700 rounded w-3/4"></div>
//             <div className="h-32 bg-gray-700 rounded w-full"></div>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

export const ProfileButtonSkeleton = () => (
  <div className="animate-pulse flex gap-3">
    {[1, 2, 3].map((i) => (
      <div key={i} className="w-10 h-10 bg-gray-700 rounded-full"></div>
    ))}
  </div>
);

export const UnlockCardSkeleton = () => (
  <div className="animate-pulse p-4 bg-gray-800 rounded-lg">
    <div className="flex items-center gap-3 mb-4">
      <div className="w-8 h-8 bg-gray-700 rounded"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-700 rounded w-32"></div>
        <div className="h-3 bg-gray-600 rounded w-48"></div>
      </div>
    </div>
    <div className="h-10 bg-gray-700 rounded w-full"></div>
  </div>
);

export const SectionCardSkeleton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="w-full flex p-[16px] flex-col items-start gap-[20px] rounded-[8px] border-[1px] border-solid border-[#262626]">
    <div className="flex flex-col items-start gap-[8px] self-stretch">
      <div className="flex items-start gap-[8px] self-stretch">
        <Skeleton className="h-[20px] w-[24px]" />
        <Skeleton className="h-[20px] w-[120px]" />
      </div>
      <Skeleton className="h-[20px] w-[200px]" />
    </div>
    {children}
  </div>
);
